// Sales Operating System — shared frontend constants (Phase 1, Preview only).
import i18n from "@/i18n/i18n";

export const SALES_STAGES = [
  "UNCONTACTED", "PROFILE_PREPARED", "CLAIM_SENT", "CLAIM_OPENED", "CLAIMED",
  "TRIAL", "PAID", "ACTIVE", "FOLLOW_UP", "NO_INTEREST", "CHURN_RISK", "CANCELLED",
];
// Stages surfaced as the dashboard funnel (in order).
export const FUNNEL_STAGES = [
  "UNCONTACTED", "PROFILE_PREPARED", "CLAIM_SENT", "CLAIM_OPENED", "CLAIMED", "TRIAL", "PAID", "ACTIVE",
];

const neutral = "bg-fundio-subtle text-fundio-muted border-fundio-border";
const info = "bg-status-info-bg text-status-info border-status-info-border";
const warning = "bg-status-warning-bg text-status-warning border-status-warning-border";
const success = "bg-status-success-bg text-status-success border-status-success-border";
const danger = "bg-status-danger-bg text-status-danger border-status-danger-border";
const gold = "bg-fundio-gold/12 text-fundio-gold-deep border-fundio-gold/30";

export const STAGE_META = {
  UNCONTACTED: { label: "Unkontaktiert", cls: neutral },
  PROFILE_PREPARED: { label: "Profil vorbereitet", cls: info },
  CLAIM_SENT: { label: "Claim gesendet", cls: info },
  CLAIM_OPENED: { label: "Claim geöffnet", cls: warning },
  CLAIMED: { label: "Beansprucht", cls: warning },
  TRIAL: { label: "Test", cls: gold },
  PAID: { label: "Bezahlt", cls: success },
  ACTIVE: { label: "Aktiv", cls: success },
  FOLLOW_UP: { label: "Follow-up", cls: warning },
  NO_INTEREST: { label: "Kein Interesse", cls: neutral },
  CHURN_RISK: { label: "Churn-Risiko", cls: danger },
  CANCELLED: { label: "Gekündigt", cls: danger },
};
export const PRIO_META = {
  A: { label: "Sales A", cls: danger },
  B: { label: "Sales B", cls: warning },
  C: { label: "Sales C", cls: neutral },
};
export const PLAN_META = {
  FREE: { label: "FREE", cls: neutral },
  LIGHT: { label: "LIGHT", cls: info },
  WEBPRO: { label: "WEBPRO", cls: gold },
  MULTI: { label: "MULTI", cls: success },
  UNKNOWN: { label: "—", cls: neutral },
};
export const CLAIM_META = {
  NONE: { label: "Nicht vorbereitet", cls: neutral },
  PROFILE_PREPARED: { label: "Profil vorbereitet", cls: info },
  CLAIM_SENT: { label: "Gesendet", cls: info },
  CLAIM_OPENED: { label: "Geöffnet", cls: warning },
  CLAIMED: { label: "Beansprucht", cls: success },
};

// Kanonische Claim-Status (echte Werte aus der Plattform-API, Phase 2C).
export const CANONICAL_CLAIM_META = {
  PREPARED: { label: "Vorbereitet", cls: info },
  SENT: { label: "Gesendet", cls: info },
  OPENED: { label: "Geöffnet", cls: warning },
  CLAIMED: { label: "Beansprucht", cls: success },
  EXPIRED: { label: "Abgelaufen", cls: neutral },
  REVOKED: { label: "Widerrufen", cls: danger },
};
export const ACTIVE_CLAIM_STATUSES = ["PREPARED", "SENT", "OPENED"];
export const CLAIM_LANGS = [
  ["de", "Deutsch"], ["fr", "Français"], ["it", "Italiano"], ["en", "English"],
];

export function formatChf(n) {
  if (n === null || n === undefined) return "—";
  const lang = (i18n.language || "de").slice(0, 2);
  const loc = { de: "de-CH", fr: "fr-CH", it: "it-CH", en: "en-CH" }[lang] || "de-CH";
  return `CHF ${Number(n).toLocaleString(loc)}.–`;
}

// i18n-aware label helpers. `cls` stays in the *_META maps above; labels resolve via
// the current locale (fallback = the German label baked into the map).
export const stageLabel = (v) => i18n.t(`sales.stages.${v}`, STAGE_META[v]?.label || v);
export const prioLabel = (v) => i18n.t(`sales.prio.${v}`, PRIO_META[v]?.label || v);
export const planLabel = (v) => i18n.t(`sales.plan.${v}`, PLAN_META[v]?.label || v);
export const claimMetaLabel = (v) => i18n.t(`sales.claimMeta.${v}`, CLAIM_META[v]?.label || v);
export const canonicalClaimLabel = (v) => i18n.t(`sales.canonicalClaim.${v}`, CANONICAL_CLAIM_META[v]?.label || v);
